import React from "react";
import "./PGASweatsSummarySection.css";
import PGASweatsGraphDisplay from "../PGASweatsGraphDisplay";
import { graphql, useLazyLoadQuery } from "react-relay";
import FlexBreak from "../../../../../FlexBreak";

const DATA_FOR_CONTEST = graphql`
  query PGASweatsSummarySectionQuery($contestId: ID!, $playerId: ID) {
    cutSummaryForContest(contestId: $contestId, playerId: $playerId) {
      cutSummary {
        madeCut
        numLineups
      }

      totalNumLineups
    }

    scoreSummaryForContest(contestId: $contestId, playerId: $playerId) {
      pointsSummary {
        bucketMin
        numLineups
      }

      totalNumLineups
    }

    draftkingsContestById(contestId: $contestId) {
      slate {
        cutLine
        cutIsOfficial
      }
    }
  }
`;

export default function PGASweatsSummarySection({
  contestId,
  playerId,
  graphWidth,
}) {
  const data = useLazyLoadQuery(
    DATA_FOR_CONTEST,
    {
      contestId: contestId,
      playerId: playerId,
    },
    { fetchPolicy: "network-only" }
  );

  const numCutLineups = data.cutSummaryForContest.totalNumLineups;
  const numScoreLineups = data.scoreSummaryForContest.totalNumLineups;

  let cutLine = data.draftkingsContestById.slate.cutLine;
  const cutIsOfficial = data.draftkingsContestById.slate.cutIsOfficial;

  const cutData = React.useMemo(() => {
    return data.cutSummaryForContest.cutSummary.map((cutsEntry) => {
      return {
        name: cutsEntry.madeCut,
        val: Math.round((cutsEntry.numLineups / numCutLineups) * 100),
      };
    });
  }, [contestId, playerId]);

  const pointsData = React.useMemo(() => {
    return data.scoreSummaryForContest.pointsSummary.map((pointsEntry) => {
      console.log(pointsEntry);
      return {
        name: `${pointsEntry.bucketMin}+`,
        val: Math.round((pointsEntry.numLineups / numScoreLineups) * 100),
      };
    });
  }, [contestId, playerId]);

  console.log(pointsData);

  const width = graphWidth ? graphWidth : "49%";

  try {
    cutLine = parseInt(cutLine);
    // eslint-disable-next-line no-empty
  } catch {}

  return (
    <>
      <p>
        <strong>
          {cutIsOfficial ? "OFFICIAL" : "PROJECTED"} Cut Line is{" "}
          {cutLine > 0 ? "+" : ""}
          {cutLine}
        </strong>
      </p>
      <FlexBreak />

      <PGASweatsGraphDisplay data={cutData} height={250} width={width} />
      <PGASweatsGraphDisplay data={pointsData} height={250} width={width} />
    </>
  );
}
